import instance from "../instance";


export const profileApi = {
  getLicenses: (profileId, offset) => instance.get(`/v1/profiles/${profileId}/licenses?verbose_level=2&offset=${offset ?? '0'}`),
  deleteLicense: (profileId, licenseId) => instance.delete(`/v1/profiles/${profileId}/licenses/${licenseId}`),
  addLicense: (profileId, values) => {
    console.log(profileId, values)
    return instance.post(`/v1/profiles/${profileId}/licenses`, values)
  },
  editLicense: (profileId, licenseId, values) => {
    console.log(profileId, licenseId, values)
    return instance.patch(`/v1/profiles/${profileId}/licenses/${licenseId}`, values)
  },
  getDraftResume: () => instance.get(`/v1/logbook/resume-draft?verbose_level=2`),
  updateResume: (values) => instance.patch(`/v1/logbook/resume-draft?verbose_level=2`, values),
  addResumeLicenses: (licenseIds) => instance.put(`/v1/logbook/resume-draft/licenses`, licenseIds !== null ? licenseIds.map(id => ({licenses_id: id})) : []),
  getResumeLicenses: () => instance.get(`/v1/logbook/resume-draft/licenses`),
  addResumeCharters: (charterIds) => instance.put(`/v1/logbook/resume-draft/trips`, charterIds !== null ? charterIds.map(id => ({trip_id: id})) : []),
  getResumeCharters: () => instance.get(`/v1/logbook/resume-draft/trips`),
  sendResume: (id, body) => {
    console.log(`/v1/logbook/resume/${id}/send`, body)
    return instance.post(`/v1/logbook/resume/${id}/send`, body)
  },
  getIytLicenses: (iytId, profileId) => instance.get(`/v1/profiles/${profileId}/licenses/import/iyt?iyt_id=${iytId}&verbose_level=2`),
  getSharedResume: (resume_id) => instance.get(`/v1/logbook/resume/${resume_id}/preview`),
  getFavoriteYachts: (profileId, offset) => instance.get(`/v1/profiles/${profileId}/favorite-yachts?verbose_level=2&offset=${offset ?? '0'}`),
  addFavoriteYacht: (yacht_id, profileId) => instance.post(`/v1/profiles/${profileId}/favorite-yachts`, {yacht_id}),
  deleteFavoriteYacht: (profileId, yachtId) => instance.delete(`/v1/profiles/${profileId}/favorite-yachts/${yachtId}`),
  getTeam: () => instance.get('/v1/logbook/team')
}
